import endpoints from "../../utils/endpoints";
import { publicAxios as axios } from "../../config/axios";
import globalConstant from "../../utils/constants";
import { mapPartSearchHit } from "@svan-garaaz/reactsharedlib";
import type { ResolvedPartForPrefill } from "./testPrefillConfig";

class Services {
  async placeGaraazOrder(payload: any) {
    const response = await axios({
      method: globalConstant.POST,
      url: endpoints.placeGaraazOrder,
      data: payload,
      headers: {
        Authorization: localStorage.getItem("auth_orca"),
      },
    });
    return response.data;
  }

  async getXpressCustomer(search: string) {
    const response = await axios({
      method: globalConstant.GET,
      url: endpoints.getXpressCustomer(search),
      headers: {
        Authorization: localStorage.getItem("auth_orca"),
      },
    });
    return response.data;
  }
  async addMedia(payload: any) {
    const response = await axios({
      method: globalConstant.POST,
      url: endpoints.addMedia,
      data: payload,
      headers: {
        Authorization: localStorage.getItem("auth_orca"),
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  }
  async deleteMedia(mediaId: string) {
    const response = await axios({
      method: globalConstant.DELETE,
      url: endpoints.deleteMedia(mediaId),
      headers: {
        Authorization: localStorage.getItem("auth_orca"),
      },
    });
    return response.data;
  }
  async getOrderMediaConfig() {
    const response = await axios({
      method: globalConstant.GET,
      url: endpoints.mobileConfig,
      headers: {
        Authorization: localStorage.getItem("auth_orca"),
      },
    });
    return response.data;
  }
  async getCarMakers() {
    const response = await axios({
      method: globalConstant.GET,
      url: endpoints.getCarMakers(),
      headers: {
        Authorization: localStorage.getItem("auth_orca"),
      },
    });
    return response.data;
  }
  async getStateCity() {
    const response = await axios({
      method: globalConstant.GET,
      url: endpoints.getStateCity,
      headers: {
        Authorization: localStorage.getItem("auth_orca"),
      },
    });
    return response.data;
  }
  async getInsurers() {
    const response = await axios({
      method: globalConstant.GET,
      url: endpoints.getInsurers,
      headers: {
        Authorization: localStorage.getItem("auth_orca"),
      },
    });
    return response.data;
  }

  async getCustomerForPrefill(customerId: string) {
    const response = await axios({
      method: globalConstant.GET,
      url: endpoints.getXpressCustomer(customerId),
      headers: {
        Authorization: localStorage.getItem("auth_orca"),
      },
    });
    const customers = Array.isArray(response.data) ? response.data : [];
    return (
      customers.find(
        (customer: { _id?: string }) =>
          String(customer?._id) === String(customerId),
      ) ??
      customers[0] ??
      null
    );
  }

  async getPartMasterById(partId: string) {
    const response = await axios({
      method: globalConstant.GET,
      url: `/part-master/${partId}`,
      headers: {
        Authorization: localStorage.getItem("auth_orca"),
      },
    });
    return response.data?.partMaster ?? null;
  }

  async searchPartsForPrefill(query: string, brand?: string) {
    try {
      const response = await axios({
        method: globalConstant.GET,
        url: "/part-master/typesense-part-search",
        params: {
          q: query,
          page: 1,
          limit: 20,
          ...(brand?.trim() ? { brand: brand.trim() } : {}),
        },
        headers: {
          Authorization: localStorage.getItem("auth_orca"),
        },
      });
      return response.data?.items ?? [];
    } catch {
      return [];
    }
  }

  async resolvePartForPrefill(
    partId: string,
    options?: { partNumber?: string; partName?: string; carMaker?: string },
  ) {
    const configFallback = (): ResolvedPartForPrefill | null => {
      const partNumber = options?.partNumber?.trim() ?? "";
      const partName = options?.partName?.trim() ?? "";
      if (!partNumber && !partName) return null;
      return { _id: partId, partNumber, partName };
    };

    let partMaster: Record<string, unknown> | null = null;
    try {
      partMaster = await this.getPartMasterById(partId);
    } catch {
      partMaster = null;
    }

    if (partMaster?.partNumber || partMaster?.partName) {
      return {
        _id: partId,
        partNumber: String(partMaster.partNumber ?? options?.partNumber ?? ""),
        partName: String(partMaster.partName ?? options?.partName ?? ""),
        mrp: Number(partMaster.mrp ?? 0),
        brandId: partMaster.brandId as string | undefined,
        brandName: String(partMaster.brand ?? ""),
        hsnCode: String(partMaster.hsnCode ?? ""),
        rootPartNumber: String(partMaster.rootPartNumber ?? ""),
      };
    }

    const searchQuery =
      options?.partNumber?.trim() ||
      options?.partName?.trim() ||
      String(partMaster?.partNumber ?? "").trim() ||
      String(partMaster?.partName ?? "").trim();

    if (searchQuery) {
      const items = await this.searchPartsForPrefill(
        searchQuery,
        options?.carMaker,
      );
      for (const item of items) {
        const hit = mapPartSearchHit(item);
        if (hit && String(hit._id) === String(partId)) {
          return { ...hit, _id: partId };
        }
      }

      const firstHit = mapPartSearchHit(items[0]);
      if (firstHit?.partNumber || firstHit?.partName) {
        return { ...firstHit, _id: partId };
      }
    }

    return configFallback();
  }
}
export default new Services();
